// Copyright (C) 2017-2023 Smart code 203358507

const App = require('./App');

module.exports = App;
